import { ApiTagTypes, innovorderApi } from '../index';
import { ApiRequest, ApiResponse } from '../request.types';
import {
    AssignOperationZonePayload,
    AssignOperationZoneResponse,
    ConfigureOperationZonePayload,
    GetRestaurantOperationZonesPayload,
    RemoveOperationZonePayload,
    RestaurantOperationZonesResponse,
    SetPrimaryOperationZonePayload,
} from './operationZone.type';

const operationZoneApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        getRestaurantOperationZones: build.query<
            RestaurantOperationZonesResponse,
            ApiRequest<GetRestaurantOperationZonesPayload>
        >({
            query: ({ restaurantId, token }) => ({
                url: `/api/v1/restaurants/${restaurantId}/operation-zones`,
                method: 'GET',
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            transformResponse: (response: ApiResponse<RestaurantOperationZonesResponse>) => response.data,
            providesTags: [ApiTagTypes.OperationZone],
            extraOptions: { maxRetries: 3 },
        }),
        configureOperationZone: build.mutation<void, ApiRequest<ConfigureOperationZonePayload>>({
            query: ({ restaurantId, operationZoneId, token, ...body }) => ({
                url: `/api/v1/restaurants/${restaurantId}/operation-zones/${operationZoneId}/configure`,
                method: 'PUT',
                body,
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            invalidatesTags: [ApiTagTypes.OperationZone],
            extraOptions: { maxRetries: 0 },
        }),
        assignOperationZone: build.mutation<AssignOperationZoneResponse, ApiRequest<AssignOperationZonePayload>>({
            query: ({ restaurantId, token, ...body }) => ({
                url: `/api/v1/admin/restaurants/${restaurantId}/operation-zones/assign`,
                method: 'POST',
                body,
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            transformResponse: (response: ApiResponse<AssignOperationZoneResponse>) => response.data,
            invalidatesTags: [ApiTagTypes.OperationZone],
            extraOptions: { maxRetries: 0 },
        }),
        removeOperationZone: build.mutation<void, ApiRequest<RemoveOperationZonePayload>>({
            query: ({ restaurantId, token, ...body }) => ({
                url: `/api/v1/restaurants/${restaurantId}/operation-zones/remove`,
                method: 'DELETE',
                body,
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            invalidatesTags: [ApiTagTypes.OperationZone],
            extraOptions: { maxRetries: 0 },
        }),
        setPrimaryOperationZone: build.mutation<void, ApiRequest<SetPrimaryOperationZonePayload>>({
            query: ({ restaurantId, token, ...body }) => ({
                url: `/api/v1/restaurants/${restaurantId}/operation-zones/set-primary`,
                method: 'PUT',
                body,
                headers: {
                    authorization: `Bearer ${token}`,
                },
            }),
            invalidatesTags: [ApiTagTypes.OperationZone],
            extraOptions: { maxRetries: 0 },
        }),
    }),
});

export const {
    useGetRestaurantOperationZonesQuery,
    useConfigureOperationZoneMutation,
    useAssignOperationZoneMutation,
    useRemoveOperationZoneMutation,
    useSetPrimaryOperationZoneMutation,
} = operationZoneApi;
